module.exports = __webpack_public_path__ + "img/agreement.be8e4b19.png";